import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormStatus } from 'app/core/types/aus-form-types';

@Component({
  selector: 'aus-rv-tabs',
  templateUrl: './aus-rv-tabs.component.html'
})
export class AusRVTabsComponent {
  @Input() isAUSCountry: boolean;
  @Input() tabs: any;
  @Input() ausTabs: any[];
  @Input() ausPreTravelTabs: any[];
  @Input() selectedTab: string;
  @Output() tabSelected = new EventEmitter<{ tab: any, category: string }>();
  @Output() ausRvtabTypeSelected = new EventEmitter();
  @Input() submitted_notes_types: string[] = [];
  @Input() submitted_treatment_types: string[] = [];
  @Input() preRaceFormsStatus: string = '';
  @Input() preTravelFormsStatus: string = '';


  setTab(tab: any, category: string) {
    this.tabSelected.emit({ tab, category });
  }

  onPreTravelTabSelect() {
    this.tabs.isPreTravelTab = true;
    this.ausRvtabTypeSelected.emit();
  }

  onPreTravelTabDeselect() {
    this.tabs.isPreTravelTab = false;
    this.resetTabs()
    //this.ausRvtabTypeSelected.emit();
  }

  onPreRaceTabSelect() {
    this.tabs.isPreRaceTab = true;
    this.ausRvtabTypeSelected.emit();
  }

  onPreRaceTabDeselect() {
    this.tabs.isPreRaceTab = false;
    this.resetTabs()
    //this.ausRvtabTypeSelected.emit();
  }

  resetTabs() {
    this.tabs.isTreatments = false;
    this.tabs.isNotes = false;
    this.tabs.isVaccinations = false
  }

  isSubmitted(type: string) {
    const noteTypeIndex = this.submitted_notes_types.findIndex(_type => _type == type);
    if (noteTypeIndex >= 0) return true;
    const treatmentTypeIndex = this.submitted_treatment_types.findIndex(_type => _type == type);
    if (treatmentTypeIndex >= 0) return true;

    return false
  }

  getClassNameBasedOnStatus(formStatus: string) {
    var className = '';

    switch (formStatus) {
      case FormStatus.Inprogress:
        className = 'tabs-inprogress'
        break;
      case FormStatus.Submitted:
        className = 'tabs-submitted'
        break;
      case FormStatus.Accepted:
        className = 'tabs-accepted'
        break;
    }

    return className
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/aus-rv-tabs/aus-rv-tabs.component.ts